export const Urls = {
	index: '/',
	velgdimensjoneringsmetode: '/velgdimensjoneringsmetode',
	dimensjoneringsGrunnlag: '/dimensjoneringsgrunnlag',
	dimensjonering: '/dimensjonering',
	mekanistiskEmpiriskDimensjonering: '/dimensjonering/mekanistiskempirisk',
	posisjon: '/posisjon',
	grunnlag: '/grunnlag',
	mekanistiskEmpiriskGrunnlag: '/mekanistiskempiriskgrunnlag',
	innlogging: '/login',
	export: '/export',
	backoffice: {
		index: '/backoffice',
		demo: '/backoffice/demo',
		icons: '/backoffice/demo/icons',
		weatherStations: '/backoffice/weatherstation',
		materialer: '/backoffice/materialer',
		unleashToggles: '/backoffice/unleash',
	},
};
